import { render, staticRenderFns } from "./Advantages2.vue?vue&type=template&id=350ae038&lang=pug&"
import script from "./Advantages2.vue?vue&type=script&lang=js&"
export * from "./Advantages2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports